import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import {
  sTrnTyp,
  ErrorMsgDetail,
  GetItemFullSearchArr,
  fItemCodeDependency,
  GetSearchItem,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  GetUnitArr,
  fValidationDetail_Client,
  fValidationHead_Client,
  //item
  GCToggleSearch_ItemName_Columns,
  GCToggleSearch_ItemName_Select_Arr,

  //save
  fSaveHead,
  fLoad_Grid,
  fSaveDetail,
  fApproveDetail,
  MultiCardFlag,
} from "./WmsPhysicalStockCountAction";
import {
  fAlertToast,
  fKeyTabInput,
  fcovertToNumber,
  GetCheck_Monthend_DueDate,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
  Get_ToggleDropDown_binsearch_Load2,
} from "../../Utility/Utilitys";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import { fExecuteAPI } from "../../Server/Apis";
import {
  Set_SliceWmsPhysicalStockCount_CountingDetail,
  Set_SliceWmsPhysicalStockCount_HeadObj,
  Set_SliceWmsPhysicalStockCount_HeadObj_Init,
  Set_SliceWmsPhysicalStockCount_HeadObj_New_Set,
  Set_SliceWmsPhysicalStockCount_HeadObject_A_DocStat,
} from "./SliceWmsPhysicalStockCount";
import React, { useState, useEffect, useRef, useCallback } from "react";

import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import WmsPhysicalStockCountBreadcrumbs from "./WmsPhysicalStockCount_BreadCrumbs";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./WmsPhysicalStockCount.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { WmsPhysicalStockCountDetailTblCard } from "./processComponent/WmsPhysicalStockCountDetailTblCard";
import { PhysicalStockCount_Count_Delete } from "../../Server/ApiV2";
import { useNavigate } from "react-router-dom";
import { WmsPhysicalStockCountRo } from "../../Redux/roStore";

export default function WmsPhysicalStockCountDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BarcodeFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const Detail_Grid_columns = [
    {
      field: "B_SheetId",
      headerName: "Sheet No",
      width: 150,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "B_SrNo",
      headerName: "Sr No",
      width: 50,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "B_CardID",
      headerName: "CardID",
      width: 150,
    },
    {
      field: "BinName",
      headerName: "BinName",
      width: 300,
    },
    {
      field: "B_Qty",
      headerName: "Qty",
      width: 50,
    },
    {
      field: "B_ItmCd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 320,
    },
    {
      field: "B_BinCd",
      headerName: "BinCd",
      width: 50,
      hide: true,
    },
    {
      field: "B_Unit",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "B_BaseQty",
      headerName: "Base Qty",
      width: 100,
      hide: vMediaQuery ? true : false,
    },
  ];
  const vRdxHead = useSelector(
    (state) => state.SliceWmsPhysicalStockCount.value.CountingDetail
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const vInitHeadError = {
    SheetNo: "",
    Loc: "",
    LocName: "",
    Date: "",
    ReferenceNo: "",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    SheetNo: "",
    Loc: "",
    LocName: "",
    Date: "",
    ReferenceNo: "",
  });

  const fDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_SliceWmsPhysicalStockCount_CountingDetail({
          ...vRdxHead,
          Date: "",
        })
      );
    } else {
      dispatch(
        Set_SliceWmsPhysicalStockCount_CountingDetail({
          ...vRdxHead,
          Date: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_SliceWmsPhysicalStockCount_HeadObj({
    //     ...vRdxHead,
    //     Date: event.$d,
    //   })
    // );
  };

  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  const [sDetail_Grid_Row, setDetail_Grid_Row] = useState([]);
  const sRoundingVal = 4;
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.B_SrNo,
      B_CardId: item.row.B_CardID,
      B_Itmcd: item.row.B_ItmCd,
      B_ItmName: item.row.ItmName,
      B_BinCode: item.row.B_BinCd,
      B_BinName: item.row.BinName,
      B_Qty: item.row.B_Qty,
      SuppRefNo1: item.row.SuppRefNo1,
      BarCode: item.row.BarCode,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_ItmCd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue.PackDesc,
    }));
    fCloseViewModal();
  };

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_CardId: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_BinCode: "",
    B_BinName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
  };

  const [sBufferObj, setBufferObj] = useState({
    B_Srno: 0, // int
    B_CardId: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_BinCode: "",
    B_BinName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
    SuppRefNo1: "",
    BarCode: "",
  });

  const [sUnit, setUnit] = useState([]);
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };
  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("B_Qty")[0].blur();
    }
  };
  const fCardId = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_CardId: e.target.value,
    }));
  };
  const fCardId_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: "",
      B_ItmName: "",
      B_Unit: "",
      B_PackQty: 0,
      B_BaseQty: 0,
      B_Packing: 0,
      SuppRefNo1: "",
      BarCode: "",
    }));
    setUnit([]);
  };

  //API NOTIFICATION_PICKINGCARDIDSEARCH_GETROW
  const GetCartIDDetail = async (xCardId) => {
    const CartBarcodeDetailObj = {
      v_CardID: xCardId,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "BIN_TRANSFER_CARD_ID",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: CartBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: CartBarcodeDetail.ResultSet[0].Name2,
          SuppRefNo1: CartBarcodeDetail?.ResultSet[0]?.SuppRefNo1,
        }));

        let vItemSearchFull = await GetItemFullSearchArr(
          CartBarcodeDetail.ResultSet[0].ItmCd,
          vRdxHead.locCode
        );

        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            setBufferObj,
            setUnit,
            CartBarcodeDetail.ResultSet[0].Unit
          );
        }
      } else {
        fCardId_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else {
      fAlertToast(
        "FAILED",
        CartBarcodeDetail?.Message || CartBarcodeDetail.response.data.message
      );
    }
  };
  const GetBarcodeDetail = async (xBarcode, xeditRow) => {
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_Loc: vRdxHead.locCode,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "PHYSICALSTOCK_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: vBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: vBarcodeDetail.ResultSet[0].Name2,
          B_CardId: vBarcodeDetail.ResultSet[0].CardID,
          SuppRefNo1: vBarcodeDetail?.ResultSet[0]?.SuppRefNo1,
        }));
        let vItemSearchFull = await GetItemFullSearchArr(
          vBarcodeDetail.ResultSet[0].ItmCd,
          vRdxHead.locCode
        );
        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            setBufferObj,
            setUnit,
            vBarcodeDetail.ResultSet[0].Unit
          );
        }
      } else {
        fCardId_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong barcode Id");
      }
    } else {
      fAlertToast(
        "FAILED",
        vBarcodeDetail?.Message || vBarcodeDetail?.response?.data?.message
      );
    }
  };
  const fCardIdEnter = async (e) => {
    if (e.key === "Enter") {
      if (sBufferObj.B_CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      } else {
        // GetCartIDDetail(sBufferObj.B_CardId);
        if (sBufferObj.B_BinCode !== "" && sBufferObj.B_BinName !== "") {
          const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load2(
            sBufferObj.B_BinName,
            "Any",
            "Y",
            vRdxHead.locCode
          );
          if (
            (vReasonWmBin.length > 0 && vReasonWmBin[0]?.OpenBin == "Y") ||
            MultiCardFlag()
          ) {
            GetBarcodeDetail(sBufferObj.B_CardId, false);
          } else {
            GetCartIDDetail(sBufferObj.B_CardId, false);
          }
        } else {
          fAlertToast("FAILED", "BinName is empty");
          setTimeout(() => {
            document.getElementById("GC_Toggle_Head_BinName_Name")?.focus();
          }, 100);
        }
      }
    } else if (e.key === "Backspace") {
      fCardId_BackSpace_Clear();
    }
  };

  //Modal ItemSearch start
  const [
    GCToggleSearch_ItemName_Grid_Row,
    set_GCToggleSearch_ItemName_Grid_Row,
  ] = useState([]);
  //Item Dropdowm
  const [GCToggleSearch_ItemName_Toggle, set_GCToggleSearch_ItemName_Toggle] =
    useState(false);
  const [GCToggleSearch_ItemName_Obj, set_GCToggleSearch_ItemName_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const Toggle_ItemSearch = () => {
    if (GCToggleSearch_ItemName_Toggle) {
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      set_GCToggleSearch_ItemName_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      set_GCToggleSearch_ItemName_Toggle(true);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  const GCToggleSearch_ItemName_Sub_Input = (e) => {
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fItemToggleClick = (e) => {
    set_GCToggleSearch_ItemName_Grid_Row([]);
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxHead.locCode,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }

    Toggle_ItemSearch();
  };

  //ItemSearch
  const GCToggleSearch_ItemName_Main_Enter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxHead.locCode
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
      }));
      setUnit([]);
    }
  };

  //Item search Start
  const GCToggleSearch_ItemName_Main_Input = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const GCToggleSearch_ItemName_RowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxHead.locCode
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    set_GCToggleSearch_ItemName_Toggle(false);
  };
  //GCItemSearch
  const GCToggleSearch_ItemName_CellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_ItemName_RowClick(newSelectionModel);
    }
  };
  const GCToggleSearch_ItemName_Sub_Enter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        GCToggleSearch_ItemName_Obj.Data,
        GCToggleSearch_ItemName_Obj.Type,
        vRdxHead.locCode,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  //Item search end

  //Bin start

  const xfGC_Toggle_Head_BinName_Name = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinName: e.target.value,
      B_CardId: "",
    }));
    fCardId_BackSpace_Clear();
  };

  const [
    sGC_Toggle_Head_BinName_SearchDropdownObj,
    setGC_Toggle_Head_BinName_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [sGC_Toggle_Head_BinName_GridData, setGC_Toggle_Head_BinName_GridData] =
    useState([]);
  const [
    sGC_Toggle_Head_BinName_ToggleDropDowm,
    setGC_Toggle_Head_BinName_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_BinName_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_GridData([]);
      setGC_Toggle_Head_BinName_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_BinName_ToggleDropDowm(true);
      set_GCToggleSearch_ItemName_Toggle(false);
    }
  }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_BinName_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sBufferObj.B_BinName,
      }));
      if (sBufferObj.B_BinName !== "") {
        const vExactSearch = await Get_ToggleDropDown_binsearch_Load2(
          sBufferObj.B_BinName,
          "Any",
          "N",
          vRdxHead.locCode
        );

        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_BinName_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_BinName_GridData([]);
        }
      }
      xfGC_Toggle_Head_BinName_Toggle();
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  //1stcall
  const fGC_Toggle_Head_BinName_onKeyUp = async (e) => {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinName: "",
    }));
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (sBufferObj.B_BinName == "") {
        fAlertToast("FAILED", "BinName is empty");
        return;
      }

      const { CountingDetail } = WmsPhysicalStockCountRo();
      if (sBufferObj.B_BinName != CountingDetail.binName) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_BinName: `Assign bin ${CountingDetail.binCode} and bin ${sBufferObj.B_BinCode} should be same`,
        }));
        return;
      }
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load2(
        sBufferObj.B_BinName,
        "Any",
        "Y",
        vRdxHead.locCode
      );

      if (vExactSearch.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_BinCode: vExactSearch[0].UId,
          B_BinName: vExactSearch[0].Name1,
        }));

        setTimeout(() => {
          const element = document.querySelector('[tabindex="101"]');
          element?.focus();
        }, 100);
      } else {
        fAlertToast("FAILED", "Wrong Bin Name");
        fGC_Toggle_Head_BinName_Dropdown_SearchModalKey(e);
      }
      if (sBufferObj.B_BinCode !== "") {
        setTimeout(() => {
          const element = document.querySelector('[tabindex="104"]');
          element?.focus();
        }, 100);
      }
    }
    if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_BinCode: "",
        B_CardId: "",
      }));
      fCardId_BackSpace_Clear();
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_BinName_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load2(
        sGC_Toggle_Head_BinName_SearchDropdownObj.Data,
        sGC_Toggle_Head_BinName_SearchDropdownObj.Type,
        "N",
        vRdxHead.locCode
      );

      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_BinName_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_BinName_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_BinName_OnRowClick = async (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinCode: e?.row?.UId,
      B_BinName: e?.row?.Name1,
    }));
    setTimeout(() => {
      const element = document.querySelector('[tabindex="104"]');
      element?.focus();
    }, 100);
    xfGC_Toggle_Head_BinName_Toggle();
  };

  const fGC_Toggle_Head_BinName_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_BinName_OnRowClick(newSelectionModel);
    }
  };

  //Bin end
  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxHead?.countStatus !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxHead?.countStatus + " mode"
        );
        return;
      }

      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );

      if (!validationDetil) return;

      // fSaveHead(true, fNewDetail, sBufferObj, dispatch);
      fSaveDetail(sBufferObj, fNewDetail);
    }, 500);
  };

  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd !== "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      // let CheckDueDate = await GetCheck_Monthend_DueDate(
      //   vRdxHead.locCode,
      //   vRdxHead.date
      // );
      // if (!CheckDueDate) return;
      if (sBufferObj.B_Itmcd == "" && !!validation) {
        confirmAlert({
          title: "Approve",
          message: "Are you want to  Approve.",
          buttons: [
            {
              className: "alertBtn",
              name: "DeletYes",
              label: "Yes",
              onClick: async () => {
                fApproveDetail(dispatch, navigate);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => "",
            },
          ],
        });
      }
    }, 500);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vInitHeadError);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    // if (sBufferObj.B_ItmName === "") {
    //   fNewHead();
    //   fNewDetail();
    //   // document?.getElementsByName("ReferenceNo")[0]?.focus();
    // }
    fNewDetail();
  };
  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  const fNewHead = async () => {
    dispatch(Set_SliceWmsPhysicalStockCount_HeadObj_Init()); // Head Clearing

    // Setting Initial List Box 0th Object
    dispatch(
      Set_SliceWmsPhysicalStockCount_HeadObj_New_Set({
        SheetNo: 0,
        Loc: vRdxDBLocation[0]?.UID,
        Date: new Date(),
        ReferenceNo: "",
      })
    );
    setDetail_Grid_Row([]);
    setBufferObj(vBufferObjInit);
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = () => {
    setBufferObj(vBufferObjInit);
    setBufferObj((obj) => ({
      ...obj,
      B_BinCode: sBufferObj.B_BinCode,
      B_BinName: sBufferObj.B_BinName,
    }));

    setUnit([]);

    fLoad_Grid(setDetail_Grid_Row);

    document.getElementsByName("B_CardId")[0]?.focus();
  };

  const fDelete = (e) => {
    if (vRdxHead.countStatus === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else if (sBufferObj.B_Srno == 0) {
      fAlertToast("FAILED", "Select one line item to delete");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // DELETESIHEAD_GETROW

  const fDeleteHead = async () => {
    let vDeleteSIHeadObj = {
      A_SheetId: vRdxHead.sheetID,
      IP: vRdxuserInfo.IP,
      UserCd: vRdxuserInfo.UserID,
      A_RefNo: "",
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIHeadObj);
    const vDeleteSIHead = await fExecuteAPI(
      "WMIPT01_deleteHead_GETROW",
      FinalObj
    );
    if (vDeleteSIHead?.Type?.toUpperCase() === "SUCCESS") {
      if (sBufferObj.B_Srno == 0) {
        // vocno,srno
        dispatch(
          Set_SliceWmsPhysicalStockCount_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );

        fAlertToast("SUCCESS", "Successfully Deleted");
      }
    } else if (vDeleteSIHead?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vDeleteSIHead?.Status);
    } else {
      fAlertToast("FAILED", vDeleteSIHead?.response?.data?.Status);
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    let vDeleteSIDetailObj = {
      B_SheetId: vRdxHead.sheetID,
      B_SrNo: sBufferObj.B_Srno,
      BinCd: vRdxHead.binCode,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await PhysicalStockCount_Count_Delete(FinalObj);

    if (vDeleteSIDetail?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail();
    }
  };

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      // http://94.200.177.214:3010/WMS/StockCount?prntyp=WMIPT01&sheet=20231000005
      let urlPrint =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/StockCount?prntyp=" +
        xPrnTyp +
        "&sheet=" +
        vRdxHead.sheetID;
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxHead.sheetID, vRdxDBKernObj]
  );

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      setGC_Toggle_Head_BinName_GridData([]);
    }
  }, []);
  // useEffect(() => {
  //   const handleClick = (event) => {
  //     if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
  //       const toggleElement = event.target.closest(".toggleSearch");

  //       if (!toggleElement) {
  //         setGC_Toggle_Head_BinName_ToggleDropDowm(false);
  //       }
  //     }
  //   };
  //   document.addEventListener("click", handleClick);
  //   return () => {
  //     document.removeEventListener("click", handleClick);
  //   };
  // }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);
  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty: fcovertToNumber(sBufferObj.B_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);
  useEffect(() => {
    fLoad_Grid(setDetail_Grid_Row);
  }, []);
  useEffect(() => {
    BarcodeFocusOnLoad?.current?.focus();
  }, []);

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  useEffect(() => {
    GetGitterColumns(
      setSummaryGridColumn2,
      "PHYSTK_SUMMARY",
      Detail_Grid_columns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid ">
      <div className="Breadcrumbs">
        <WmsPhysicalStockCountBreadcrumbs />
      </div>
      <div className="WmsPhysicalStockCount-detail">
        {/* <WmsHead
          xref={BarcodeFocusOnLoad}
          vRdxHead={vRdxHead}
          xErrorMsg={sErrorMsg}
        /> */}

        <WmsContent
          xref={BarcodeFocusOnLoad}
          vRdxHead={vRdxHead}
          sEnterKeyObj={sEnterKeyObj}
          vMediaQuery={vMediaQuery}
          xContent_Focus={fContent_Focus}
          xContent_Blur={fContent_Blur}
          xErrorMsgDetail={sErrorMsgDetail}
          xBufferObj={sBufferObj}
          sUnit={sUnit}
          fUnit={fUnit}
          fQty={fQty}
          fQty_Enter={fQty_Enter}
          fCardId={fCardId}
          fCardIdEnter={fCardIdEnter}
          //GC toggle
          fItemName={GCToggleSearch_ItemName_Main_Input} //onchange main input
          xMediaQuery={vMediaQuery} //mobile screen
          xonClickbtn={GCToggleSearch_ItemName_Main_Enter} // onclick icon open div on main screen
          xrows={GCToggleSearch_ItemName_Grid_Row} //Grid Row GCToggle Search from API
          xcolumns={GCToggleSearch_ItemName_Columns} //GCToggleSearch-Grid col GCToggle Search fron Action
          xRowCellClick={GCToggleSearch_ItemName_CellClick} //GCToggleSearch-grid clic
          xRowClick={GCToggleSearch_ItemName_RowClick} //GCToggleSearch- grid click
          xToggle={GCToggleSearch_ItemName_Toggle} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
          xData={GCToggleSearch_ItemName_Select_Arr} // GCToggleSearch-select-tag arr
          xOnChangeDropdownInput={GCToggleSearch_ItemName_Sub_Input} //GCToggleSearch-input search onchane DATA/TYPE
          xDropdownObj={GCToggleSearch_ItemName_Obj} // GCToggleSearch-object DATA/TYPE
          xOnKeyUpDropdownInput={GCToggleSearch_ItemName_Sub_Enter} //GCToggleSearch-
          //customer

          xGC_Toggle_Head_BinName_DropDown_Arr={
            xGC_Toggle_Head_BinName_DropDown_Arr
          } //sub input arr
          xfGC_Toggle_Head_BinName_Name={xfGC_Toggle_Head_BinName_Name} //onchange main input
          xGC_Toggle_Head_BinName_Toggle={
            sGC_Toggle_Head_BinName_ToggleDropDowm
          } //boolean true  false
          xGC_Toggle_Head_BinName_onKeyUp={fGC_Toggle_Head_BinName_onKeyUp} //main input enter
          xGC_Toggle_Head_BinName_SearchDropdownObj={
            sGC_Toggle_Head_BinName_SearchDropdownObj
          } //sub input obj
          xGC_Toggle_Head_BinName_Dropdown_onChange={
            fGC_Toggle_Head_BinName_Dropdown_onChange
          } //sub input onchange
          xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load={
            fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load
          } //sub input load
          xGC_Toggle_Head_BinName_GridColumns={
            xGC_Toggle_Head_BinName_GridColumns
          } //sub input col
          xGC_Toggle_Head_BinName_GridData={sGC_Toggle_Head_BinName_GridData} //sub input grid
          xfGC_Toggle_Head_BinName_OnCellKeyDown={
            fGC_Toggle_Head_BinName_OnCellKeyDown
          } //sub input row enter
          xfGC_Toggle_Head_BinName_OnRowClick={
            fGC_Toggle_Head_BinName_OnRowClick
          } //sub input row click
        />
        <Grid
          container
          className="my-2"
          spacing={{ xs: 1, sm: 1, md: 0 }}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{
            alignItems: "center",
            justifyContent: vMediaQuery ? "start" : "center",
          }}
        >
          <Grid item xs={4} sm={4} md={2.2} lg={2.2}>
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId={"IdNew"}
              xSendIcon={<AddBoxRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2.2} lg={2.2}>
            <CmpButton
              xbtnName="Save"
              xOnClick={fSave}
              xVariant="contained"
              xDisabled={vRdxHead.countStatus !== "ENTER"}
              xSize="small"
              xId={"IdSave"}
              xSendIcon={<SaveRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2.2} lg={2.2}>
            <CmpButton
              xbtnName="Delete"
              xOnClick={fDelete}
              xVariant="contained"
              xDisabled={vRdxHead.countStatus !== "ENTER"}
              xSize="small"
              xId="IdDelete"
              xSendIcon={<DeleteRoundedIcon />}
            />
          </Grid>

          <Grid
            item
            xs={4}
            sm={4}
            md={2.5}
            // className="xs-dontShowInMobileView"
          >
            <CmpButton
              xbtnName="Bin Close"
              xOnClick={fApprove}
              xVariant="contained"
              xDisabled={vRdxHead.countStatus !== "ENTER"}
              xSize="small"
              xId={"IdApprove"}
              xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
          </Grid>

          {/* <Grid item xs={4} sm={4} md={2.2} lg={2.2} className="xs-screen-hide">
            <CmpButton
              xbtnName="Print"
              xOnClick={() => {
                fPrint(sTrnTyp);
              }}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId="IdPrint"
              xSendIcon={<LocalPrintshopIcon />}
            />
          </Grid> */}
          <Grid
            item
            xs={4}
            sm={4}
            md={2.2}
            lg={2.2}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Detail"
              xOnClick={fView}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid>
          {/* <Grid
            item
            xs={4}
            sm={4}
            md={2.2}
            lg={2.2}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Summary"
              xOnClick={fSummary}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid> */}
        </Grid>
        <div className="mt-5 xs-screen-hide">
          <WmsPhysicalStockCountDetailTblCard
            data={sDetail_Grid_Row}
            onClick={fDetail_Grid_onRowClick}
          />

          {/* <Box sx={{ height: "35vh", width: "100%" }}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sDetail_Grid_Row}
              columns={sSummaryGridColumn2}
              hideFooter={sDetail_Grid_Row.length < 100}
              onRowClick={fDetail_Grid_onRowClick}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            />
          </Box> */}
        </div>
      </div>
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail "} onClose={fCloseViewModal} />
          <WmsPhysicalStockCountDetailTblCard
            data={sDetail_Grid_Row}
            onClick={fDetail_Grid_onRowClick}
          />
        </Box>
      </Modal>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsHead xref={BarcodeFocusOnLoad} vRdxHead={vRdxHead} />
          </div>
        </Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
